import React from "react";
import { Skeleton, Row, Col } from "antd";

export type SkeletonFieldType = "input" | "textarea" | "select" | "radio";

export interface ISkeletonField {
  type: SkeletonFieldType;
  span: number;
}

export interface IFormSkeletonProps {
  layout: ISkeletonField[][];
}

const FormSkeleton: React.FC<IFormSkeletonProps> = ({ layout }) => {
  return (
    <>
      {layout.map((row, rowIndex) => (
        <Row gutter={16} key={`skeleton-row-${rowIndex}`} style={{ marginBottom: 24 }}>
          {row.map((item, colIndex) => (
            <Col span={item.span} key={`skeleton-col-${rowIndex}-${colIndex}`}>
              <div data-testid="skeleton-input">
              <Skeleton.Input
                active
                block
                style={{
                  width: "100%",
                  height: item.type === "textarea" ? 80 : 40,
                }}
              />
              </div>
            </Col>
          ))}
        </Row>
      ))}
    </>
  );
};

export default FormSkeleton;
